export default {
  'app.default.title': '{appName} - API Documentation',
  'app.default.keywords':
    '{appNamePrefix}API Design, API Specification, API Test, API Documentation, API Mock',
  'app.default.description':
    '{appNamePrefix}Design. Debug. Test. Document. Mock. Build APIs Faster & Together.',
};
